import register from '../../util/init';
import {flickity} from '../../util/flickity';
import InfScr from '../../util/infscr';
import {bindingToolInit} from './binding-tool';
import handleAjaxPageLoad from '../ajax-page';
import {enableAjaxLoad, tabletPortrait, phoneMax} from '../site';
import {findClosest, getOffset, windowSize} from '../../util/miscellaneous';
import $ from 'jquery';

function shiftContent (container) {
  // create duplicates of content to change layouts for phone
  // re-arange content for tablet portrait and phone
  if (!container.querySelector('.goods.duplicate') && container.querySelector('.duplicate-this')) {
    const duplicateContent = container.querySelector('.duplicate-this');
    const closestFlex = findClosest(duplicateContent, '.flex');
    let duplicateGoods = document.createElement('div');
    duplicateGoods.className = 'goods duplicate';
    duplicateGoods.innerHTML = duplicateContent.innerHTML;
    closestFlex.appendChild(duplicateGoods);

    // RE-bind filters
    // duplicateGoods.querySelectorAll('.filter input').forEach((radiobox) => {
    //   radiobox.addEventListener('change', (e) => {
    //     filterProducts(radiobox);
    //   });
    // });
    // RE-bind filters toggle
    if (duplicateGoods.querySelector('.filter-tools .filter-title')) {
      duplicateGoods.querySelector('.filter-tools .filter-title span').addEventListener('click', (e) => {
        bindFilterToggle(container);
      });
    }
  }

  if (container.querySelector('.related-stories-duplicate') &&
      container.querySelector('.related-stories-duplicate').children.length === 0) {
    const duplicateRelated = container.querySelector('.aside-layout').cloneNode(true);
    container.querySelector('.related-stories-duplicate').appendChild(duplicateRelated);
  }
}

// function filterProducts (checked) {
//   // almost a duplicate of collection filtering
//   const goods = findClosest(checked, '.goods');
//   const productList = goods.querySelectorAll('.product-list .product');
//   const setFilters = [];
//   const matchingProducts = [...productList];
//   document.querySelectorAll('.filter input:checked').forEach((filter) => {
//     // collect all current set filters
//     setFilters.push(filter.value);
//   });
//   if (setFilters.length > 0) {
//     productList.forEach((product) => {
//       // now display the related products, assume
//       const productFilters = product.getAttribute('data-filters');
//       let match;
//       setFilters.forEach((filter) => {
//         // only need a single match, if one matches carry it through
//         match = match === true ? true : productFilters.includes(filter) | '';
//       });
//       if (match === true) {
//         product.classList.remove('not-matching');
//       } else {
//         product.classList.add('not-matching');
//         matchingProducts.pop(product)
//       }
//     });
//   } else {
//     // nothing selected, display all
//     productList.forEach((product) => {
//       product.classList.remove('not-matching');
//     });
//   }
//   document.querySelector('.filter-tools .count .number').innerHTML = matchingProducts.length
// }

function bindFilterToggle (container) {
  const parentElement = windowSize().width > phoneMax ? '.duplicate-this' : '.duplicate';
  const filter = container.querySelector(`${parentElement} .filter-tools .filter`)
  if (filter.classList.contains('open')) {
    filter.classList.remove('open');
  } else {
    filter.classList.add('open');
  }
}

function bindAnchors (anchorTrigger) {
  anchorTrigger.addEventListener('click', (e) => {
    const groupID = anchorTrigger.getAttribute('data-anchor');
    const parentElement = windowSize().width > phoneMax ? '.duplicate-this' : '.duplicate';
    const groupElement = document.querySelector(`${parentElement} #${groupID}`);
    // when collection ajax loads to article, the group elements are removed
    // in this case, hard load the page back to the collecion page + group hash
    if (groupElement) {
      const scrollTo = getOffset(groupElement).top;
      e.preventDefault();
      window.scroll({
        top: scrollTo,
        left: 0,
        behavior: 'smooth'
      });
    }
  });
}

function collectionCollection (container) {
  $('.unordered-product-list .product').each(function () {
    const group = $(this).data('group');
    $(".group[data-group='" + group + "'] .product-list").append($(this));
    $(".group[data-group='" + group + "']").removeClass('hidden');
  });

  let duplicated = ''
  if (window.innerWidth < tabletPortrait) {
    shiftContent(container);
    duplicated = '.duplicate ';
  }

  const infscr = InfScr(duplicated + '.paginate', {
    contentSelector: '.page',
    nextSelector: '.next-page',
    autoOffset: 1500,
    allowCache: false,
    beforeLoad: function () {
      // nothing here...
    },
    onLoad: function (newContent, container) {
      newContent.find('.product').each(function () {
        const group = $(this).data('group');
        $(duplicated + ".group[data-group='" + group + "'] .product-list").append($(this));
        $(duplicated + ".group[data-group='" + group + "']").removeClass('hidden');
      });
      if ($(duplicated + '.paginate .unordered-product-list').length > 1) {
        $(duplicated + '.paginate .unordered-product-list').first().remove();
      }
      if ($(duplicated + '.paginate .next-page').length > 1) {
        $(duplicated + '.paginate .next-page').first().remove();
      }
    }
  });

  if (container.querySelector('.binding-tool')) {
    bindingToolInit(container.querySelector('.binding-tool'));
  }
  // bind ajax links
  container.querySelectorAll('.ajax-link').forEach((ajaxTrigger) => {
    ajaxTrigger.addEventListener('click', (e) => {
      var modifier = e.shiftKey || e.ctrlKey || e.metaKey;
      if (enableAjaxLoad && !modifier) {
        e.preventDefault();
        handleAjaxPageLoad(ajaxTrigger, 'collection-product');
      }
    });
  });

  // bind anchors in aside
  container.querySelectorAll('.anchors a[data-anchor]:not(.anchor-bound)').forEach((anchorTrigger) => {
    anchorTrigger.classList.add('anchor-bound');
    bindAnchors(anchorTrigger);
  });

  container.querySelectorAll('.gallery').forEach((el) => {
    if (el.childElementCount > 1) {
      flickity(el, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
      });
    }
  });

  // bind filters
  // container.querySelectorAll('.filter input').forEach((radiobox) => {
  //   radiobox.addEventListener('change', (e) => {
  //     filterProducts(radiobox);
  //   });
  // });

  // bind filter open/close
  if (container.querySelector('.filter-tools .filter-title')) {
    container.querySelector('.filter-tools .filter-title span').addEventListener('click', (e) => {
      bindFilterToggle(container);
    });
  }

  container.querySelectorAll('.filters-filter').forEach(filter => {
    const pathArr = window.location.pathname.split('/');
    if (filter.tagName === 'SELECT') {
      let selIndex = 0;
      for (let i = 0; i < filter.options.length; i++) {
        if (filter.dataset.filter === pathArr[2] && filter.options.item(i).value === pathArr[3]) {
          selIndex = i;
        }
      }
      if (filter.nextSibling && filter.nextSibling.tagName === 'SPAN') {
        filter.nextSibling.innerHTML = filter.options[selIndex].innerHTML;
      }
      filter.options[selIndex].selected = true;
    }
  });

  return {
    resize: (w, h) => {
      if (w < tabletPortrait) {
        shiftContent(container);
      }
      infscr.resize(w, h);
    },
    scroll: (...args) => {
      infscr.scroll.apply(infscr, args);
    }
  };
}
register('collection-collection', collectionCollection);



// WEBPACK FOOTER //
// ./assets/j/src/collection/collection.js